/**
 * Small markup utility class
 */
import unescape from 'lodash/unescape';
import striptags from 'striptags';

const markupHelper = {
  /**
   * Replace anchor tag with span tag
   * @param {string} str
   */
  stripAnchor(str) {
    return str.replace(/<a (.)+?>/gi, '<span>').replace(/<\/a>/gi, '</span>');
  },

  unescape(str) {
    return unescape(str).replace(/&nbsp;/g, ' ');
  },

  stripTags(str) {
    return markupHelper.unescape(striptags(str));
  },
};

export default markupHelper;
